import { render, staticRenderFns } from "./Depositos.vue?vue&type=template&id=c45da120&"
import script from "./Depositos.vue?vue&type=script&lang=js&"
export * from "./Depositos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports